import React, { useEffect, useRef, useState } from 'react';
import MultiSelect from 'react-multiselect-checkboxes';
import { addMinutes, formatISO } from 'date-fns';
import {
  Modal,
  ModalBody,
  ModalFooter,
  Button,
  FormGroup,
  Input,
  Label,
  Row,
  Col,
} from 'reactstrap';
import NotificationAlert from 'react-notification-alert';
import DatePicker from 'react-datepicker';
import { startOfToday } from 'date-fns';
import 'react-datepicker/dist/react-datepicker.css';
import 'react-datepicker/dist/react-datepicker-cssmodules.css';
import { format } from 'date-fns';

import './add-session.css';

import ReactMultiSelectCheckboxes from 'react-multiselect-checkboxes';
import { db } from 'MY_LOGIN_AND_SIGNUP/db/config';
import { useForm } from 'react-hook-form';
import axios from 'axios';

import { CLIENT_ID, CLIENT_SECRET, REDIRECT_URI, accessToken } from 'utils';
import { Webex_Base_Url } from 'utils';
import firebase from 'firebase';
import moment from 'moment';

// import { utcToZonedTime, zonedTimeToUtc } from 'date-fns';

const IST_TIMEZONE = 'Asia/Kolkata';

const AddSession = ({
  getMeetings,
  handleClose,
  isEditing,
  editData,
  setOpenAddSession,
}) => {
  const functions = firebase.functions();

  const [sessionData, setSessionData] = useState({});
  const [batchList, setBatchList] = useState([]);
  const [selectedBatches, setSelectedBatches] = useState([]);
  const [currentUser, setCurrentUser] = useState({});

  const [teacherList, setTeacherList] = useState([]);
  const [selectedTeacher, setSelectedTeacher] = useState([]);
  const [selectedStudents, setSelectedStudents] = useState([]);

  const [isTeacherFree, setIsTeacherFree] = useState(true);
  const [isStatrtTimeValid, setIsStartTimeValid] = useState(true);

  const [isCreating, setIsCreating] = useState(false);

  const handleInputChange = (e) => {
    if (sessionData.recurrence == 'none' && e?.target?.name == 'startDate') {
      setSessionData({
        ...sessionData,
        [e?.target?.name]: e?.target?.value,
        lastDate: e?.target?.value.split('T')[0],
      });
    } else {
      setSessionData({
        ...sessionData,
        [e?.target?.name]: e?.target?.value,
      });
    }
  };

  const notifi = useRef();
  const notify = (msg, err) => {
    // console.log('notify')
    let color = err == false ? 'success' : 'danger';
    let options = {
      type: color,
      place: 'tr',
      message: (
        <div>
          <div>
            <b>{err == false ? 'Success' : 'Error'}</b> - {msg}.
          </div>
        </div>
      ),
      icon: 'tim-icons icon-bell-55',
      autoDismiss: 6,
    };
    if (notifi.current) {
      notifi.current.notificationAlert(options);
    }
    // notification(options);
  };

  console.log(isTeacherFree, 'isTeacherFree');

  const getCurrentUser = () => {
    firebase.auth().onAuthStateChanged((user) => {
      if (user) {
        db.collection('zSystemUsers')
          .doc(user.uid)
          .get()
          .then((query) => {
            let data = query.data();
            console.log(data, 'currentUser');
            setCurrentUser({
              isTeacher: data.isTeacher || false,
              createdBy: data._uniqueID,
              creatorName: data.firstname + ' ' + data.lastname,
            });
          });
      }
    });
  };

  const selectedBatchIdExtractor = () => {
    return selectedBatches?.map((batch) => batch?.value);
  };

  const handleRecurrenceChangeForEndDate = () => {
    let recurrenceRule = '';

    let lastDate = sessionData?.lastDate;

    if (lastDate) {
      const untilFormatted =
        new Date(lastDate).toISOString().replace(/[-:]/g, '').split('.')[0] +
        'Z';

      const startDate = new Date(sessionData?.startDate);
      const weekStartDay = ['SU', 'MO', 'TU', 'WE', 'TH', 'FR', 'SA'][
        startDate.getDay()
      ];
      const startWeekday = ['SU', 'MO', 'TU', 'WE', 'TH', 'FR', 'SA'][
        startDate.getDay()
      ];

      switch (sessionData?.recurrence) {
        case 'daily':
          recurrenceRule = `FREQ=DAILY;INTERVAL=1;UNTIL=${untilFormatted}`;
          break;
        case 'weekly':
          recurrenceRule = `FREQ=WEEKLY;INTERVAL=1;WKST=${weekStartDay};BYDAY=${startWeekday};UNTIL=${untilFormatted}`;
          break;
        case 'weekdays':
          recurrenceRule = `FREQ=WEEKLY;INTERVAL=1;BYDAY=MO,TU,WE,TH,FR;UNTIL=${untilFormatted}`;
          break;
        case 'monthly':
          recurrenceRule = `FREQ=MONTHLY;INTERVAL=1;BYMONTHDAY=${startDate.getDate()};UNTIL=${untilFormatted}`;
          break;
        case 'yearly':
          recurrenceRule = `FREQ=YEARLY;INTERVAL=1;BYMONTH=${
            startDate.getMonth() + 1
          };BYMONTHDAY=${startDate.getDate()};UNTIL=${untilFormatted}`;
          break;
        case 'none':
          recurrenceRule = null;
          break;
        default:
          break;
      }
    }

    return recurrenceRule;
  };

  const getStudentsOfSelectedBatches = async () => {
    try {
      const selectedBatchIds = selectedBatchIdExtractor();
      if (selectedBatchIds.length < 1) return [];
      const studentsRef = db.collection('zSystemStudents');

      const snapshot = await studentsRef
        .where('batch', 'array-contains-any', selectedBatchIds)
        .get();
      if (snapshot.empty) {
        return;
      }

      const students = snapshot.docs.map((doc) => {
        console.log(doc.data(), 'docDataStudents');
        let data = doc.data();
        return {
          id: doc.id,
          firstname: data?.firstname,
          lastname: data?.lastname,
          email: data?.email,
        };
      });
      setSelectedStudents(students);
    } catch (error) {}
  };

  const getTeachersOfSelectedBatches = async () => {
    try {
      const selectedBatchIds = selectedBatchIdExtractor();
      if (selectedBatchIds.length < 1) return [];
      const studentsRef = db.collection('zSystemUsers');

      const snapshot = await studentsRef
        .where('isBatchManage', 'array-contains-any', selectedBatchIds)
        .where('isTeacher', '==', true)
        .where('status', '==', 0)
        .get();
      if (snapshot.empty) {
        return;
      }

      const teachers = snapshot.docs.map((doc) => {
        console.log(doc.data(), 'docDataTeacher');
        let data = doc.data();
        return {
          id: doc.id,
          firstname: data?.firstname,
          lastname: data?.lastname,
          email: data?.email,
          isTeacher: data?.isTeacher,
        };
      });
      console.log(teachers, 'teachhh');
      if (isEditing) {
        const teacher = teachers?.filter(
          (teacher) => teacher.email === editData?.invitees?.email
        )[0];

        setSelectedTeacher({
          label: teacher.firstname + teacher.lastname,
          value: teacher.email,
        });
      }
      setTeacherList(teachers);
    } catch (error) {}
  };

  const getBatch = () => {
    db.collection('Batch')
      .where('type', '==', 'batch')
      .get()
      .then((querySnapshot) => {
        let data = querySnapshot.docs.map((doc) => doc.data());

        if (isEditing) {
          const batches = data?.filter((batch) =>
            editData?.BatchIds.includes(batch.itemID)
          );

          setSelectedBatches(
            batches.map((batch) => ({
              label: batch.batchName,
              value: batch.itemID,
            }))
          );
        }

        setBatchList(data);
      });
  };

  function extractRRuleComponents(rruleStr) {
    if (rruleStr) {
      const components = rruleStr.split(';');
      const result = {};

      components.forEach((component) => {
        const [key, value] = component.split('=');
        if (key === 'FREQ' || key === 'UNTIL') {
          result[key] = value;
        }
      });
      return result;
    } else {
      return '';
    }
  }

  function calculateEndDate(startDate, durationInMinutes) {
    if (!startDate || !durationInMinutes) {
      return;
    }
    const start = new Date(startDate);
    const end = addMinutes(start, durationInMinutes); // Add minutes

    // Format date to "YYYY-MM-DDTHH:mm"
    const formatDate = (date) =>
      formatISO(date, { representation: 'complete' }).slice(0, 16);

    return {
      endDate: formatDate(end),
    };
  }

  const updateFirebaseMeet = async (webExMeetingId, updateData) => {
    try {
      const batchClassesRef = db.collection('BatchClasses');
      const querySnapshot = await batchClassesRef
        .where('webExMeetingId', '==', webExMeetingId)
        .limit(1)
        .get();

      if (querySnapshot.empty) {
        console.log('No matching document found to update.');
        return;
      }

      const doc = querySnapshot.docs[0];
      await doc.ref.update(updateData);

      notify('Meeting updated successfully', false);
    } catch (error) {
      notify(error?.message, true);
    }
  };

  const onSubmitHandler = async (e) => {
    e?.preventDefault();
    let token = accessToken();
    console.log(sessionData, 'sessionDatasessionData');
    if (!isTeacherFree) {
      notify('Teacher is not available on selected time', true);
      return;
    }
    if (!isStatrtTimeValid && !isEditing) {
      notify('Selected time should be 5minutes after current time', true);
      return;
    }
    if (!selectedTeacher?.value) {
      notify('Teacher not selected', true);
      return;
    }
    const requestBody = {
      title: sessionData.title,
      start: sessionData?.startDate,
      end: calculateEndDate(sessionData?.startDate, sessionData?.duration)
        ?.endDate,
      timezone: 'Asia/Kolkata',
      hostEmail: 'tncollege@outlook.com',
      sendEmail: false,
      enabledAutoRecordMeeting: true,
      audioConnectionOptions: { muteAttendeeUponEntry: true },
      unlockedMeetingJoinSecurity: 'allowJoin',
      invitees: [
        // {
        //   displayName: 'Nilanjan Admin',
        //   email: 'admin@nilanjansinha-2xmk.wbx.ai',
        //   coHost: true,
        // },
        {
          displayName: selectedTeacher?.label,
          email: selectedTeacher?.value,
          coHost: true,
        },
        // ...selectedStudents?.map((student) => ({
        //   displayName: student?.firstname + ' ' + student?.lastname,
        //   email: student?.email,
        //   coHost: false,
        // })),
      ],
    };
    if (sessionData?.recurrence) {
      requestBody.recurrence = handleRecurrenceChangeForEndDate();
      if (!sessionData?.lastDate && sessionData?.recurrence !== 'none') {
        notify('Repeat till can not be empty', true);
        return;
      }
    }
    setIsCreating(true);
    if (!isEditing) {
      try {
        // if (!isEditing) {
        const meetData = await axios.post(
          `${Webex_Base_Url}/v1/meetings`,
          requestBody,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              'Content-Type': 'application/json',
            },
          }
        );
        // } else {
        // }

        const convertToTimestamp = (dateString) => {
          const date = new Date(dateString);
          return firebase.firestore.Timestamp.fromDate(date);
        };

        const endTime = calculateEndDate(
          sessionData?.startDate,
          sessionData?.duration
        )?.endDate;
        const createMeetData = {
          title: sessionData.title,
          start: sessionData?.startDate, //show start Date and Time
          lastDate:
            sessionData.lastDate || sessionData?.startDate?.split('T')[0], //repeat Till Date only like 2025-04-15
          end: endTime, // only use For End Time
          frequency: sessionData.recurrence || 'none', // enum daily,weekly,weekdays,monthly,none
          hostEmail: selectedTeacher?.value || null,
          BatchIds: selectedBatches.map((batch) => batch?.value),
          invitees: {
            displayName: selectedTeacher?.label,
            email: selectedTeacher?.value,
            coHost: true,
          },

          webExMeetingId: meetData.data.id,
          meetData: meetData.data,
          status: 'yetToStart',
          createdAt: firebase.firestore.FieldValue.serverTimestamp(),
        };

        if (createMeetData.frequency == 'weekdays')
          createMeetData.weekDays = [
            'monday',
            'tuesday',
            'wednesday',
            'thursday',
            'friday',
          ];
        console.log(createMeetData.frequency, 'weekly');
        if (createMeetData.frequency == 'weekly') {
          const startDate = new Date(sessionData?.startDate);
          const dayName = startDate
            .toLocaleDateString('en-US', { weekday: 'long' })
            .toLowerCase();
          createMeetData.weekDays = [dayName];
          console.log('exicuted', dayName);
        }

        if (createMeetData.frequency === 'monthly') {
          const startDate = new Date(sessionData?.startDate);
          createMeetData.monthDay = startDate.getDate();
          console.log('executed monthDate', createMeetData.monthDay);
        }
        console.log('exicuted 1', createMeetData);
        const meetingRef = await db
          .collection('BatchClasses')
          .add(createMeetData);
        console.log('exicuted 2');

        const firstMeetDate = sessionData?.startDate.split('T');
        const occurrenceRef = meetingRef
          .collection('occurrences')
          .doc(firstMeetDate[0]); //2025-04-03
        const subMeetData = {
          date: firstMeetDate[0], //2025-04-03
          actualStartTime: firstMeetDate[1], // 21:00
          actualEndTime: endTime.split('T')[1], // 22:00
          status: 'yetToStart', // or 'yetToStart'
        };
        console.log(subMeetData, 'subMeetDatasubMeetData');
        await occurrenceRef.set(subMeetData);

        console.log(meetData, token, 'meetData');
        setIsCreating(false);
        notify('Class Created Successfuly', false);
        getMeetings();
        handleClose();
      } catch (err) {
        setIsCreating(false);
        console.log(err, 'show Err 1');
        notify(
          'Message from Webex:' + ' ' + err?.response?.data?.message ||
            'Something Went Wrong',
          true
        );
      }
    } else {
      try {
        // if (!isEditing) {
        const meetData = await axios.patch(
          `${Webex_Base_Url}/v1/meetings/${editData?.meetData?.id}`,
          requestBody,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              'Content-Type': 'application/json',
            },
          }
        );
        // } else {
        // }

        const createMeetData = {
          title: sessionData.title,
          start: sessionData?.startDate,
          end: calculateEndDate(sessionData?.startDate, sessionData?.duration)
            ?.endDate,
          hostEmail: selectedTeacher?.value || null,
          BatchIds: selectedBatches.map((batch) => batch?.value),
          invitees: {
            displayName: selectedTeacher?.label,
            email: selectedTeacher?.value,
            coHost: true,
          },
          lastDate:
            sessionData.lastDate || sessionData?.startDate?.split('T')[0],
          frequency: sessionData.recurrence || 'none',
          webExMeetingId: meetData.data.id,
          meetData: meetData.data,
          status: 'yetToStart',
          createdAt: firebase.firestore.FieldValue.serverTimestamp(),
        };

        await updateFirebaseMeet(meetData.data.id, createMeetData);

        console.log(meetData, token, 'meetData');
        setIsCreating(false);
        // notify('Class Updated Successfuly', false);
        getMeetings();
        handleClose();
      } catch (err) {
        setIsCreating(false);
        console.log(err, 'show Err 2');
        notify(
          'Message from Webex:' +
            ' ' +
            err?.response?.data?.errors[0]?.description ||
            'Something Went Wrong',
          true
        );
      }
    }
  };
  console.log(sessionData);

  useEffect(() => {
    if (selectedBatches?.length > 0) {
      getStudentsOfSelectedBatches();
      getTeachersOfSelectedBatches();
    }
  }, [selectedBatches]);

  // const fetchBatchClasses = async () => {
  //   const storeQuizDataFunction = functions.httpsCallable('getBatchClassesV2');
  //   const response = await storeQuizDataFunction({BatchIds:[]});
  //   console.log(response.data, 'response.data');
  // }

  useEffect(() => {
    // fetchBatchClasses()
    getCurrentUser();
    getBatch();
  }, []);

  const inputStyle = {
    backgroundColor: '#2c2f47',
    color: '#fff',
    border: '1px solid #5a5e75',
    maxWidth: '100%',
  };
  const customStyles = {
    option: (provided, state) => ({
      ...provided,
      color: state.isSelected ? '#272a3d' : 'black',
      padding: 10,
    }),
    control: () => ({
      display: 'none',
    }),
  };

  const repeatOptions = [
    { label: 'Daily', value: 'daily' },
    { label: 'Weekly', value: 'weekly' },
    { label: 'Weekdays (Mon-Fri)', value: 'weekdays' },
    { label: 'Monthly', value: 'monthly' },
    { label: 'Never', value: 'none' },
  ];
  function isTimeWithinRange(startDate, endDate, selectedDate) {
    const start = new Date(startDate);
    const end = new Date(endDate);
    const selected = new Date(selectedDate);

    const toMinutes = (date) => date.getHours() * 60 + date.getMinutes();

    const startMinutes = toMinutes(start);
    const endMinutes = toMinutes(end);
    const selectedMinutes = toMinutes(selected);

    return selectedMinutes >= startMinutes && selectedMinutes <= endMinutes;
  }

  const getMeeting = async () => {
    if (selectedTeacher?.value || sessionData?.startDate) {
      let payload = {
        startDate: `${sessionData?.startDate?.slice(0, 10)}T23:59`,
        lastDate: `${sessionData?.startDate?.slice(0, 10)}`,
        teacherEmail: selectedTeacher?.value,
      };

      const functions = firebase.functions();
      const getClasses = functions.httpsCallable('getBatchClassesV2');
      const response = await getClasses(payload);

      let classes = response?.data?.data || [];

      let conflictFound = false;

      if (isEditing) {
        classes = classes?.filter(
          (item) => item?.webExMeetingId != editData?.webExMeetingId
        );
      }

      classes.forEach((item) => {
        if (
          isTimeWithinRange(
            item?.meetData?.start,
            item?.meetData?.end,
            sessionData?.startDate
          )
        ) {
          conflictFound = true;
        }
      });

      if (conflictFound) {
        setIsTeacherFree(false);

        notify('Teacher is not available on selected time', true);
      } else {
        setIsTeacherFree(true);
      }
    }
  };

  const getTomorrowDate = () => {
    const tomorrow = new Date();
    tomorrow.setDate(tomorrow.getDate() + 1);
    const year = tomorrow.getFullYear();
    const month = String(tomorrow.getMonth() + 1).padStart(2, '0');
    const day = String(tomorrow.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };

  const tomorrow = getTomorrowDate();

  const isAtLeastFiveMinutesInFuture = (selectedDateTimeString) => {
    const selectedTime = new Date(selectedDateTimeString);
    const now = new Date();
    const fiveMinutesLater = new Date(now.getTime() + 5 * 60 * 1000);

    return selectedTime > fiveMinutesLater;
  };

  function getTimeDifferenceInMinutes(dateStr1, dateStr2) {
    const date1 = new Date(dateStr1);
    const date2 = new Date(dateStr2);

    const diffMs = Math.abs(date2 - date1); // difference in milliseconds
    const diffMins = Math.floor(diffMs / 60000); // convert ms to minutes

    return diffMins;
  }

  useEffect(() => {
    if (sessionData?.startDate) {
      const isValid = isAtLeastFiveMinutesInFuture(sessionData?.startDate);

      if (isValid) {
        setIsStartTimeValid(true);
      } else {
        setIsStartTimeValid(false);
        if (!isEditing) {
          notify('Selected time should be 5minutes after current time', true);
        }
      }
    }
    if (selectedTeacher && sessionData?.startDate) {
      getMeeting();
    }
  }, [
    selectedTeacher,
    sessionData?.startDate,
    sessionData?.sessionData?.lastDate,
  ]);

  // useEffect(() => {
  //   if (!isTeacherFree) {
  //     notify('Teacher is not available on selected time', true);
  //   }
  // }, [isTeacherFree]);

  const formatDateForInput = (dateString) => {
    const date = new Date(dateString);
    const offsetDate = new Date(
      date.getTime() - date.getTimezoneOffset() * 60000
    ); // make it local
    return offsetDate.toISOString().slice(0, 16); // 'YYYY-MM-DDTHH:MM'
  };

  useEffect(() => {
    if (isEditing && editData) {
      console.log(
        editData,
        repeatOptions?.filter(
          (rule) =>
            rule?.value?.toLowerCase() == sessionData?.recurrence?.toLowerCase()
        )[0],
        'editData'
      );
      const reccurssion = extractRRuleComponents(
        editData?.meetData?.recurrence
      );

      setSessionData({
        ...sessionData,
        recurrence: editData?.frequency,
        lastDate: reccurssion?.UNTIL
          ? `${reccurssion?.UNTIL.slice(0, 4)}-${reccurssion?.UNTIL.slice(
              4,
              6
            )}-${reccurssion?.UNTIL.slice(6, 8)}`
          : '',
        title: editData?.title,
        duration: getTimeDifferenceInMinutes(
          editData?.meetData?.start,
          editData?.meetData?.end
        ),
        startDate: formatDateForInput(editData?.meetData?.start),
      });
      // setBatchList(editData?.BatchIds);
      // teacherList?.map((teacher) => {});
    }
  }, [isEditing, editData, teacherList]);

  return (
    <div className='session-container'>
      <div className='react-notification-alert-container'>
        <NotificationAlert ref={notifi} />
      </div>
      <h4 className='add-session-header'>Add Class</h4>
      <form onSubmit={onSubmitHandler}>
        <div className='add-session-form-container'>
          {/* Quiz Name */}
          <Row>
            <Col>
              <FormGroup>
                <Label style={{ color: '#fff' }}>Class Name*</Label>
                <Input
                  required
                  // {...register('title', {
                  //   required: true,
                  //   minLength: 4,
                  // })}
                  name='title'
                  type='text'
                  value={sessionData.title}
                  onChange={handleInputChange}
                  placeholder='Enter class name'
                  style={inputStyle}
                />
              </FormGroup>
            </Col>
          </Row>

          <Row>
            <Col>
              <FormGroup>
                <Label style={{ color: '#fff' }}>Select Batches*</Label>

                <ReactMultiSelectCheckboxes
                  styles={customStyles}
                  value={selectedBatches}
                  getDropdownButtonLabel={({
                    placeholderButtonLabel,
                    value,
                  }) => {
                    if (value && value.length !== 0) {
                      return `${value?.length} selected`;
                    } else {
                      return `Select`;
                    }
                  }}
                  onChange={(option, e) => {
                    setSelectedBatches(option);
                  }}
                  options={batchList.map((item) => ({
                    label: item.batchName,
                    value: item.itemID,
                  }))}
                />
              </FormGroup>
            </Col>

            <Col>
              <FormGroup>
                <Label style={{ color: '#fff' }}>Select Teacher*</Label>
                <MultiSelect
                  value={selectedTeacher}
                  options={
                    teacherList?.length > 0
                      ? teacherList?.map((teacher) => ({
                          label: teacher?.firstname + ' ' + teacher?.lastname,
                          value: teacher?.email,
                        }))
                      : []
                  }
                  onChange={(option) => {
                    setSelectedTeacher(option);
                  }}
                  placeholder='Select Teacher'
                  isMulti={false}
                  styles={{
                    control: (base) => ({
                      ...base,
                      borderRadius: '7px',
                      minHeight: '40px',
                    }),
                    menu: (base) => ({
                      ...base,
                      zIndex: 9999,
                    }),
                  }}
                />
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col>
              <FormGroup>
                <Label style={{ color: '#fff' }}>Start Time*</Label>
                {/* <div className='date-container'> */}
                {/* <Input
                  className='form-control'
                  style={{
                    display: 'block',
                    width: '100%',
                    height: '35px',
                    outline: 'none',
                    background: 'transparent',
                    color: 'white',
                    borderRadius: '4px',
                    padding: '2px',
                  }}
                  type='datetime-local'
                  name='startDate'
                  onChange={handleInputChange}
                  value={sessionData?.startDate}
                  required
                ></Input> */}

                <div style={{ color: 'white', fontFamily: 'sans-serif' }}>
                  {/* <label style={{ display: 'block', marginBottom: '8px' }}>
                    Start Time
                  </label> */}
                  <DatePicker
                    selected={
                      sessionData?.startDate
                        ? new Date(sessionData.startDate)
                        : null
                    }
                    onChange={(date) =>
                      setSessionData({
                        ...sessionData,
                        lastDate: '',
                        startDate: moment(date?.toISOString()).format(
                          'YYYY-MM-DDTHH:mm'
                        ),
                      })
                    }
                    timeIntervals={15}
                    showTimeSelect
                    dateFormat='dd/MM/yyyy, hh:mm aa'
                    placeholderText='dd/mm/yyyy, --:-- --'
                    minDate={startOfToday()}
                    className='form-control'
                    popperPlacement='bottom-start'
                    calendarClassName='dark-datepicker'
                  />
                  <style jsx>{`
                    .form-control {
                      background-color: transparent;
                      border: 1px solid #333a54;
                      color: white;
                      width: 100% !important;
                      height: 35px;
                      padding: 4px 10px;
                      border-radius: 4px;
                      outline: none;
                      font-size: 0.875rem;
                    }

                    .form-control::placeholder {
                      color: white;
                    }

                    .dark-datepicker {
                      background-color: #1c1b2d;
                      color: white;
                    }

                    .dark-datepicker .react-datepicker__header {
                      background-color: #1c1b2d;
                      border-bottom: 1px solid #333;
                    }

                    .dark-datepicker .react-datepicker__current-month,
                    .dark-datepicker .react-datepicker__day-name {
                      color: white;
                    }

                    .dark-datepicker .react-datepicker__day {
                      color: white;
                    }

                    .dark-datepicker .react-datepicker__day--disabled {
                      color: black !important;
                      pointer-events: none;
                    }

                    .dark-datepicker .react-datepicker__day--selected {
                      background-color: #8aa8ff;
                      color: black;
                    }

                    .dark-datepicker .react-datepicker__time-container {
                      background-color: #1c1b2d;
                      border-left: 1px solid #333;
                    }

                    .dark-datepicker .react-datepicker__time {
                      background-color: #1c1b2d;
                    }

                    .dark-datepicker .react-datepicker__time-box {
                      background-color: #1c1b2d;
                    }

                    .dark-datepicker .react-datepicker__time-list-item {
                      color: white;
                    }

                    .dark-datepicker .react-datepicker__time-list-item:hover {
                      background-color: black;
                      color: black;
                    }

                    .dark-datepicker
                      .react-datepicker__time-container
                      .react-datepicker__time-caption {
                      background-color: white;
                      color: black;
                      font-weight: bold;
                      border-bottom: 1px solid #333;
                      padding: 5px;
                    }

                    .react-datepicker-wrapper {
                      width: 100%;
                    }
                  `}</style>
                </div>
                {/* </div> */}
              </FormGroup>
            </Col>

            <Col>
              <FormGroup>
                <Label style={{ color: '#fff' }}>Duration (in minutes)*</Label>
                {/* <div className='date-container'> */}
                <Input
                  className='form-control'
                  style={{
                    display: 'block',
                    width: '100%',
                    height: '35px',
                    outline: 'none',
                    background: 'transparent',
                    color: 'white',
                    borderRadius: '4px',
                    padding: '6px',
                  }}
                  type='number'
                  name='duration'
                  onChange={handleInputChange}
                  value={sessionData?.duration}
                  required
                ></Input>
                {/* </div> */}
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col>
              <FormGroup>
                <Label style={{ color: '#fff' }}>Repeat</Label>
                <MultiSelect
                  options={repeatOptions}
                  onChange={(option) =>
                    setSessionData({
                      ...sessionData,
                      recurrence: option?.value,
                      lastDate:
                        option?.value != 'none'
                          ? sessionData?.lastDate
                          : sessionData?.startDate?.split('T')[0] || '',
                    })
                  }
                  placeholder='Select Repeat'
                  isMulti={false}
                  value={
                    repeatOptions?.filter(
                      (rule) =>
                        rule?.value?.toLocaleLowerCase() ==
                        sessionData?.recurrence?.toLocaleLowerCase()
                    )[0]
                  }
                  styles={{
                    control: (base) => ({
                      ...base,
                      borderRadius: '7px',
                      minHeight: '40px',
                    }),
                    menu: (base) => ({
                      ...base,
                      zIndex: 9999,
                    }),
                  }}
                />
              </FormGroup>
            </Col>
            <Col>
              {sessionData?.recurrence &&
                sessionData?.recurrence !== 'none' && (
                  <FormGroup>
                    <Label style={{ color: '#fff' }}>Repeat Till*</Label>
                    {/* <div className='date-container'> */}
                    <Input
                      className='form-control'
                      style={{
                        display: 'block',
                        width: '100%',
                        height: '35px',
                        outline: 'none',
                        background: 'transparent',
                        color: 'white',
                        borderRadius: '4px',
                        padding: '2px',
                      }}
                      type='date'
                      name='lastDate'
                      min={
                        sessionData?.startDate
                          ? moment(sessionData?.startDate)
                              ?.add(1, 'day')
                              .format('YYYY-MM-DD')
                          : tomorrow
                      }
                      value={sessionData?.lastDate}
                      onChange={handleInputChange}
                    ></Input>
                    {/* </div> */}
                  </FormGroup>
                )}
            </Col>
          </Row>

          {/* Subject Weightage */}
        </div>
        <div
          style={{
            display: 'flex',
            justifyContent: 'flex-end',
          }}
        >
          <Button onClick={handleClose} type='button'>
            Cancel
          </Button>
          <Button disabled={isCreating} type='submit'>
            {isCreating ? 'Adding...' : 'Submit'}
          </Button>
        </div>
      </form>
    </div>
  );
};

export default React.memo(AddSession);
